import { DeleteAction } from '@hendrx/icons/DeleteAction';
import { ReplaceAction } from '@hendrx/icons/ReplaceAction';
import { ActionIcon, Flex } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import classes from '../UploadFile.module.scss';

type FileActionsProps = {
  onDelete?: () => void;
  onReplace: () => void;
  CustomResetButton?: ReactNode;
  disabled?: boolean;
  justify?: 'center' | 'flex-start' | 'flex-end';
};

export function FileActions(props: FileActionsProps) {
  const { onDelete, onReplace, CustomResetButton, disabled, justify = 'center' } = props;
  const { t } = useTranslation('components');

  return (
    <Flex align="center" justify={justify} gap={0}>
      {CustomResetButton}
      {onDelete && (
        <ActionIcon
          variant="transparent"
          className={classes.actionBtn}
          onClick={() => {
            onDelete();
          }}
          title={t('uploadFileActions.delete')}
          disabled={disabled}
          data-testId="delete-file-button"
        >
          <DeleteAction />
        </ActionIcon>
      )}
      <ActionIcon
        variant="transparent"
        className={classes.actionBtn}
        onClick={() => {
          onReplace();
        }}
        title={t('uploadFileActions.replace')}
        disabled={disabled}
        data-testId="replace-file-button"
      >
        <ReplaceAction />
      </ActionIcon>
    </Flex>
  );
}
